import { getColorByCode } from './color-languages'

function doAjax(args = {}, callback = () => {}) {
	let params = new URLSearchParams()

	for (const [key, value] of Object.entries(args)) {
		params.append(key, value)
	}

	try {
	const raw = sessionStorage.getItem('OT_CONFIG_MODAL_STATE')
	const state = raw ? JSON.parse(raw) : null

	const q7SevenSeater =
		state?.components?.q7_seven_seater ??
		window.q7SeatConfig

	if (q7SevenSeater !== undefined && q7SevenSeater !== null && q7SevenSeater !== '') {
		params.set('q7_seven_seater', q7SevenSeater)
	}
	} catch (e) {
		// console.warn('[doAjax] q7_seven_seater konnte nicht gelesen werden', e)
	}

	const loadingScreen = document.getElementById('loading-screen')
	if (loadingScreen) {
		loadingScreen.classList.add('loading')
	}

	fetch('/', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: params
	})
		.then(async res => {
			const text = await res.text()

			if (loadingScreen) {
				loadingScreen.classList.remove('loading')
			}

			if (!res.ok) {
				console.error('[doAjax] HTTP-Fehler', {
					status: res.status,
					args,
					responseText: text
				})
				return
			}

			if (!text || !text.trim()) {
				console.error('[doAjax] Leere Antwort vom Server', { args })
				return
			}

			let json

			try {
				json = JSON.parse(text.replace(/^\uFEFF/, '').trim())
			} catch (e) {
				console.error('[doAjax] JSON-Parse-Fehler', {
					args,
					errorMessage: e.message,
					responseText: text
				})
				return
			}

			try {
				callback(json)
			} catch (e) {
				console.error('[doAjax] Fehler im Callback', {
					args,
					errorMessage: e.message,
					errorStack: e.stack,
					json
				})
			}
		})
		.catch(error => {
			if (loadingScreen) {
				loadingScreen.classList.remove('loading')
			}

			console.error('[doAjax] Fetch-Fehler', {
				args,
				error
			})
		})
}

function updateTableValue(component, colorCode, tableId) {
	let valueOnTable = document.querySelector('#' + tableId + ' #' + component + ' td[color-code]')
	if (valueOnTable != null) {
		valueOnTable.setAttribute('color-code', colorCode)
		valueOnTable.innerHTML = getColorByCode(colorCode)
	}
}

/** Change stitches background depending on certain customizable components */
function initStitchesBackgroundColorListeners(baseID, stitchID, material='leather') {
	const colorsToChoose = document.querySelectorAll('#' + baseID + ' .color')
	//we do it once on load
	const chosenColorOnBase = document.querySelector('#' + baseID + ' .color.selected input').value
	changeStitchBackgroundColor(stitchID, chosenColorOnBase, material)
	//we set a listener so that it keeps updating later
	colorsToChoose.forEach(element => {
		element.addEventListener('click', function (e) {
			const chosenColorCode = element.querySelector('input').value
			changeStitchBackgroundColor(stitchID, chosenColorCode, material)
		})
	})
}

/** Changes stitch background color */
function changeStitchBackgroundColor(stitchID,color,material) {
	const backgroundImagesArray = document.querySelectorAll('#' + stitchID + ' .color-tile')
	backgroundImagesArray.forEach(element => {
		if(material == 'leather') {
			element.children[0].src = aeo['images']['color_tiles'][color]
		} else if (material == 'dinamica') {
			element.children[0].src = aeo['images']['color_tiles_softwrap_q6_etron'][color]
		} else {
			element.children[0].src = aeo['images']['color_trim_insert'][color]
		}
	});
}

/** inits logic for component matching red point  */
const initRedPointLogic = (component, componentDotId, callback = () => { }) => {
	const tiles = document.querySelectorAll('#' + componentDotId + ' .color')
	tiles?.forEach(element => {
		element.addEventListener("click", (e) => {
			e.preventDefault()
			const colorInputValue = element.querySelector('input').value
			const colorCode = colorInputValue != null ? colorInputValue : aeo['default_color']
			callback(component, colorCode);
		})
	})
}

/** Selects component color tile */
function fakeSelected(componentDotId, colorCode) {
	//unselect selected
	let lastTileSelected = document.querySelector('#' + componentDotId + ' .selected')
	lastTileSelected?.classList.remove('selected')

	//select the new one
	let tiles = document.querySelectorAll('#' + componentDotId + ' input')
	tiles?.forEach(element => {
		if (element.value == colorCode) {
			element.parentElement.classList.add('selected')
		}
	});
}

/** If master changes color, slave does as well */
function makeSlave(masterDotID, slaveDotID, slaveComponent, beingAnSlaveConditionalFunction = () => true, setImageCallback) {
	const masterTiles = document.querySelectorAll('#' + masterDotID + ' .color')
	masterTiles.forEach(element => {
		element.addEventListener('click', function (e) {
			if(beingAnSlaveConditionalFunction(masterDotID,slaveDotID)){
				const selectedTileColor = element.querySelector('input').value
				fakeSelected(slaveDotID, selectedTileColor)
				setImageCallback(slaveComponent, selectedTileColor)
			}
		},true)
	})
}

/** actives and deactivates selected */
const initColorSelect = () => {
	var colors = document.querySelectorAll(".color");
	for (var color of colors) {
		color.addEventListener("click", function (e) {
			var activeParent = this.closest(".dot.is-active");
			var selected = this.parentElement.querySelector(".selected");
			selected?.classList.remove("selected");
			this.classList.add("selected");
			if (activeParent) activeParent.classList.remove("is-active");
		},true);
	}
};

//Sets the image on top of all image array (finds img and array with ids)
// Sets the image on top of all image array (finds img and array with ids)
function setElementOnTop(imagesArrayID, topImgId) {
	const container = document.querySelector('#' + imagesArrayID)

	if (!container) {
		console.error('[setElementOnTop] Container nicht gefunden', {
			imagesArrayID,
			topImgId
		})
		return
	}

	const baseImg = container.querySelector('img:not(.overlay)')

	if (!baseImg) {
		console.error('[setElementOnTop] Kein Basisbild gefunden', {
			imagesArrayID,
			topImgId,
			container
		})
		return
	}

	const arrayParent = baseImg.parentElement

	if (!arrayParent) {
		console.error('[setElementOnTop] parentElement des Basisbilds fehlt', {
			imagesArrayID,
			topImgId,
			baseImg
		})
		return
	}

	const topImg = container.querySelector('#' + topImgId)

	if (!topImg) {
		console.error('[setElementOnTop] Zielbild nicht gefunden', {
			imagesArrayID,
			topImgId
		})
		return
	}

	const clone = topImg.cloneNode(true)
	topImg.remove()
	arrayParent.appendChild(clone)
}


export { setElementOnTop, makeSlave, initColorSelect, doAjax, updateTableValue, initStitchesBackgroundColorListeners, changeStitchBackgroundColor, initRedPointLogic, fakeSelected }